module.exports = __webpack_public_path__ + "img/kirisame magic shop.c7ff2478.png";